import { __assign, __read } from "tslib";
import React, { useState, useEffect, forwardRef, useRef, } from 'react';
import ReactDOM, { unmountComponentAtNode } from 'react-dom';
import classNames from 'classnames';
export var buyMessage = {
    success: function (options) {
        var item = __assign(__assign({}, options), { type: 'success' });
        renderBuyMessage(item);
    },
    warning: function (options) {
        var item = __assign(__assign({}, options), { type: 'warning' });
        renderBuyMessage(item);
    },
    error: function (options) {
        var item = __assign(__assign({}, options), { type: 'error' });
        renderBuyMessage(item);
    },
    loading: function (options) {
        var item = __assign(__assign({}, options), { type: 'loading' });
        renderBuyMessage(item);
    },
};
var Message = forwardRef(function (_a, ref) {
    var _b;
    var type = _a.type, content = _a.content, _c = _a.duration, duration = _c === void 0 ? 3000 : _c, className = _a.className, _d = _a.style, style = _d === void 0 ? {} : _d, onClose = _a.onClose;
    var timerRef = useRef(null);
    var _e = __read(useState(false), 2), visible = _e[0], setVisible = _e[1];
    useEffect(function () {
        setVisible(true);
        clearTimeout(timerRef.current);
        if (visible && duration !== 0) {
            timerRef.current = setTimeout(function () {
                setVisible(false);
                onClose === null || onClose === void 0 ? void 0 : onClose();
            }, duration);
        }
        return function () { return clearTimeout(timerRef.current); };
    }, [duration, visible, ref]);
    var handleClose = function () {
        clearTimeout(timerRef.current);
        setVisible(false);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    return (visible ? (React.createElement("div", { onMouseEnter: function () {
            clearTimeout(timerRef.current);
        }, onMouseLeave: handleClose, className: classNames('buy-toast-inner', (_b = {},
            _b["buy-toast-" + type] = true,
            _b), className), style: style },
        type === 'loading' ? (React.createElement("span", { className: "tea-action-state" },
            React.createElement("i", { className: "tea-mr-2n tea-icon tea-icon-loading" }),
            React.createElement("span", { className: "tea-action-state__text" }))) : (React.createElement("i", { className: "buy-icon buy-icon-" + type })),
        React.createElement("p", { className: "buy-toast-text" }, content))) : null);
});
function renderBuyMessage(props) {
    var toastRoot = document.querySelector('.buy-toast');
    if (toastRoot === null) {
        toastRoot = document.createElement('div');
        toastRoot.classList.add('buy-toast');
        document.body.appendChild(toastRoot);
    }
    var instanceRef = React.createRef();
    ReactDOM.render(React.createElement(Message, __assign({}, props, { ref: instanceRef, onClose: function () {
            var _a;
            (_a = props === null || props === void 0 ? void 0 : props.onClose) === null || _a === void 0 ? void 0 : _a.call(props);
            unmountComponentAtNode(toastRoot);
        } })), toastRoot);
}
//# sourceMappingURL=BuyMessage.js.map